import { useEffect, useState } from "react";
import api from "@/lib/api";
import { isFridayIso } from "@/lib/bookingUtils";

let cache = null;
const listeners = new Set();

export const loadSpeedboat = (force = false) => {
  if (!cache || force) {
    cache = api.get("/speedboat-schedule").then((r) => r.data);
    cache.then((s) => listeners.forEach((fn) => fn(s))).catch(() => { cache = null; });
  }
  return cache;
};

export function useSpeedboat() {
  const [s, setS] = useState(null);
  useEffect(() => {
    listeners.add(setS);
    loadSpeedboat().then(setS).catch(() => {});
    return () => { listeners.delete(setS); };
  }, []);
  return s;
}

export const isAlta = (s, iso) => {
  const md = iso.slice(5, 10);
  return s.alta_from <= s.alta_to ? md >= s.alta_from && md <= s.alta_to : md >= s.alta_from || md <= s.alta_to;
};

// orari del giorno: stagione dalla data, venerdì separato, campi vuoti esclusi
export const sbSlots = (s, iso, kind) => {
  if (!s || !iso) return [];
  const day = s[isAlta(s, iso) ? "alta" : "bassa"]?.[isFridayIso(iso) ? "venerdi" : "feriale"];
  return [...new Set((day?.[kind] || []).filter(Boolean))].sort();
};
